import React from "react"

import FeatureContainer from "@fuse/sharedComponents/FeatureContainer"

const BottomHalf = () => {
  const divStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "39px",
    width: "100%",
    paddingTop: "78px",
    paddingBottom: "78px",
    alignSelf: "stretch",
    background: "linear-gradient(98deg, #6C63FF 0%, #B592FF 100%)",
  }

  return (
    <div className="flex flex-col justify-center">
      <div style={divStyle}>
        <h1
          className="text-white font-DMSans lg:text-58 leading-70 tracking-wider text-center font-bold text-[38px] md:text-[58px]"
          style={{ fontFamily: "DM Sans" }}
        >
          Why Let’s Hang?
        </h1>
        <FeatureContainer />
      </div>
    </div>
  )
}

export default BottomHalf
